import type { FC } from 'react'
import { useCallback, useEffect, useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { CloseFullscreen, OpenInFull } from '@mui/icons-material'
import { standardTooltipProps } from '@/common/components'
import { expandControlIconButtonSx } from './ExpandControl.styles'

interface ExpandControlProps {
  readonly isExpanded: boolean
  readonly onToggle: () => void
}

export const ExpandControl: FC<ExpandControlProps> = ({ isExpanded, onToggle }) => (
  <Tooltip {...standardTooltipProps} title={isExpanded ? 'Exit fullscreen' : 'Enter fullscreen'}>
    <IconButton onClick={onToggle} size="small" sx={expandControlIconButtonSx}>
      {isExpanded ? <CloseFullscreen fontSize="small" /> : <OpenInFull fontSize="small" />}
    </IconButton>
  </Tooltip>
)

interface UseExpandDialogReturn {
  readonly isExpanded: boolean
  readonly handleToggleExpand: () => void
}

// eslint-disable-next-line react-refresh/only-export-components
export function useExpandDialog(open: boolean): UseExpandDialogReturn {
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    if (!open && isExpanded) {
      setIsExpanded(false)
    }
  }, [open, isExpanded])

  const handleToggleExpand = useCallback(() => {
    setIsExpanded((prev) => !prev)
  }, [])

  return {
    isExpanded,
    handleToggleExpand,
  }
}
